(() => {
  if (window.aceWorkSourceContextInitialized) return;
  window.aceWorkSourceContextInitialized = true;

  const IDS = new Set(['1930', '2026', '1991', '1955', '2017', '1962', '1882', '1842', '1816', '1799', '1777', '1770']);
  const OFFICIAL_IDS = new Set(['18', '303', '395', '396', '417', '462', '464', '484', '505', '900', '903', '935', '960', '963', '1006', '1020', '1072', '1080', '1112', '1146', '1147', '1324', '1346', '1361', '1438', '1469', '1507', '1548', '1614', '1617', '1654', '1669', '1698', '1714', '1723', '1746', '1806', '1854', '2016']);
  const SOURCE_BASE = 'https://www.acejimki.co.jp/works/detail.php?p=';
  const MAX_BYTES = 65536;
  const states = new WeakMap();
  const cache = new Map();
  const validId = (id) => typeof id === 'string' && (IDS.has(id) || OFFICIAL_IDS.has(id));
  const restoredId = (value) => {
    if (typeof value !== 'string' || !value.startsWith(SOURCE_BASE)) return '';
    const id = value.slice(SOURCE_BASE.length);
    return validId(id) && value === SOURCE_BASE + id ? id : '';
  };
  const assetURL = (value) => {
    try {
      const url = new URL(value, window.location.origin);
      if (!value || url.protocol !== 'https:' || url.username || url.password || url.hash) return null;
      if (url.origin !== window.location.origin && url.origin !== 'https://cdn.shopify.com') return null;
      if (!/\/ace-work-sources\.json$/.test(url.pathname)) return null;
      if ([...url.searchParams.keys()].some((key) => key !== 'v') || url.searchParams.getAll('v').length > 1) return null;
      if (url.searchParams.has('v') && !/^\d{1,30}$/.test(url.searchParams.get('v'))) return null;
      return url.href;
    } catch { return null; }
  };
  const validate = (data) => {
    if (!data || data.version !== 1 || !Array.isArray(data.works) || data.works.length !== IDS.size) throw new Error('Invalid works data');
    const works = new Map();
    data.works.forEach((work) => {
      if (!work || !validId(work.id) || works.has(work.id) || work.url !== SOURCE_BASE + work.id) throw new Error('Invalid work source');
      if (typeof work.title !== 'string' || !work.title.trim() || work.title.length > 300 || /[\u0000-\u001f\u007f]/.test(work.title)) throw new Error('Invalid work title');
      works.set(work.id, Object.freeze({ id: work.id, title: work.title.trim(), url: work.url }));
    });
    if (works.size !== IDS.size) throw new Error('Invalid works data');
    const official = data.official && typeof data.official === 'object' ? data.official : {};
    Object.keys(official).forEach((id) => {
      if (!OFFICIAL_IDS.has(id) || works.has(id)) return;
      const named = data.officialTitles && typeof data.officialTitles[id] === 'string' ? data.officialTitles[id].replace(/[\u0000-\u001f\u007f]/g, '').trim().slice(0, 80) : '';
      works.set(id, Object.freeze({ id, title: named ? named + 'の空間事例' : '事例 ' + id, url: SOURCE_BASE + id }));
    });
    return works;
  };
  const load = (source) => {
    const url = assetURL(source);
    if (!url) return Promise.reject(new Error('Invalid works asset'));
    if (cache.has(url)) return cache.get(url);
    if (cache.size >= 2) cache.delete(cache.keys().next().value);
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 12000);
    const pending = fetch(url, { credentials: 'omit', redirect: 'error', signal: controller.signal, headers: { Accept: 'application/json' } })
      .then(async (response) => {
        if (!response.ok || Number(response.headers?.get('content-length') || 0) > MAX_BYTES) throw new Error('Works unavailable');
        const text = await response.text();
        if (text.length > MAX_BYTES) throw new Error('Works too large');
        return validate(JSON.parse(text));
      })
      .catch((error) => { if (cache.get(url) === pending) cache.delete(url); throw error; })
      .finally(() => window.clearTimeout(timeout));
    cache.set(url, pending);
    return pending;
  };
  const selector = () => document.querySelector('[data-ace-works-inquiry] [data-ace-work-select]');
  const selectedId = () => {
    const select = selector();
    if (select && select.value) return select.value;
    return new URLSearchParams(window.location.search).get('ace_work_id') || '';
  };
  const updateAction = (form, id) => {
    try {
      const action = new URL(form.action, window.location.origin);
      if (action.origin !== window.location.origin) return;
      if (new URLSearchParams(window.location.search).get('view') === 'works') action.searchParams.set('view', 'works');
      if (id) action.searchParams.set('ace_work_id', id);
      else action.searchParams.delete('ace_work_id');
      form.action = action.href;
    } catch {}
  };
  const getState = (context) => {
    let state = states.get(context);
    if (state) return state;
    const form = context.closest('form');
    const title = context.querySelector('[data-ace-source-title]');
    const source = context.querySelector('[data-ace-source-url]');
    const status = context.querySelector('[data-ace-work-context-status]');
    if (!form || !title || !source || !status) return null;
    state = { form, title, source, status, active: false, phase: 'idle', revision: 0, id: '', initialized: false, restored: context.dataset.response === 'error' ? restoredId(context.dataset.aceWorkRestoredUrl || source.value) : '' };
    states.set(context, state);
    form.addEventListener('submit', (event) => {
      if (context.dataset.posted === 'true') return;
      const id = state.restored || selectedId();
      if (id !== state.id) apply(context, id);
      if (!state.active || state.phase === 'ready') return;
      event.preventDefault();
      state.status.hidden = false;
      (selector() || state.status).focus();
    }, true);
    return state;
  };
  const setStatus = (context, state, phase) => {
    state.phase = phase;
    context.dataset.aceWorkState = phase;
    state.status.textContent = phase === 'loading' ? context.dataset.aceWorkContextLoading : phase === 'error' ? context.dataset.aceWorkContextError : '';
    state.status.hidden = phase === 'ready' || phase === 'idle';
    context.setAttribute('aria-busy', phase === 'loading' ? 'true' : 'false');
  };
  const apply = (context, id) => {
    if (context.dataset.posted === 'true') return;
    const state = getState(context);
    if (!state || (state.initialized && state.id === id && state.phase !== 'error')) return;
    state.initialized = true;
    state.id = id;
    state.active = Boolean(id);
    const revision = ++state.revision;
    if (!id && state.phase === 'idle') return;

    context.dataset.ready = 'true';
    state.title.value = '';
    state.source.value = '';
    state.title.disabled = true;
    state.source.disabled = true;
    updateAction(state.form, '');
    if (!id) {
      setStatus(context, state, 'idle');
      context.hidden = ![...context.querySelectorAll('[data-ace-product-field]')].some((row) => !row.hidden);
      return;
    }
    context.hidden = false;
    setStatus(context, state, validId(id) ? 'loading' : 'error');
    if (!validId(id)) return;
    load(context.dataset.aceWorkSourcesUrl).then((works) => {
      if (state.revision !== revision || !context.isConnected || context.dataset.posted === 'true') return;
      const work = works.get(id);
      if (!work) throw new Error('Work unavailable');
      state.title.value = work.title;
      state.source.value = work.url;
      state.title.name = 'contact[参照ページ名]';
      state.source.name = 'contact[参照ページURL]';
      state.title.disabled = false;
      state.source.disabled = false;
      updateAction(state.form, work.id);
      setStatus(context, state, 'ready');
    }).catch(() => {
      if (state.revision !== revision || !context.isConnected || context.dataset.posted === 'true') return;
      setStatus(context, state, 'error');
    });
  };
  const boot = () => {
    const id = selectedId();
    document.querySelectorAll('[data-ace-inquiry-context][data-ace-work-sources-url]').forEach((context) => {
      if (context.dataset.posted === 'true') return;
      const state = getState(context);
      if (!state) return;
      const initial = state.restored || id;
      if (initial || state.active) apply(context, initial);
    });
  };
  document.addEventListener('ace:work-selected', (event) => {
    if (typeof event.detail?.id !== 'string') return;
    const id = event.detail.id;
    document.querySelectorAll('[data-ace-inquiry-context][data-ace-work-sources-url]').forEach((context) => {
      const state = getState(context);
      if (state) state.restored = '';
      apply(context, id);
    });
  });
  document.addEventListener('change', (event) => {
    if (!event.target.matches?.('[data-ace-works-inquiry] [data-ace-work-select]')) return;
    document.querySelectorAll('[data-ace-inquiry-context][data-ace-work-sources-url]').forEach((context) => {
      const state = getState(context);
      if (state) state.restored = '';
      apply(context, event.target.value);
    });
  });
  window.addEventListener('popstate', boot);
  document.addEventListener('shopify:section:load', boot);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
